import { compile } from "path-to-regexp";
import { browserName } from "react-device-detect";
import { makeBackendPostCallWithJsonResponse } from "../../store/utils/fetch";
import { UPLOAD_RELEASE_TRACKS } from "../../store/utils/routes";
import { promiseEngineEarsHandler } from "../helpers";

export interface UploadReleaseTrackArgs {
  releaseTrackId?: number;
  file: File;
}

export interface UploadReleaseTrackResponse {
  file_version_id: number;
  id: number;
  multipart_upload_id: string;
  multipart_upload_urls: string[];
  multipart_upload_chunk_size: number;
  bucket: string;
  key: string;
  parental_advisory: number;
  release: number;
  release_track_id: number;
  signed_url: string;
  supply_chain_language: number;
  supply_chain_main_genre: number;
  supply_chain_product_id: number;
  supply_chain_file_id: number;
  title: string;
  track_number: number;
}

export const uploadReleaseTrack = async (
  releaseId: number,
  { file, releaseTrackId }: UploadReleaseTrackArgs,
) => {
  const route = compile(UPLOAD_RELEASE_TRACKS)({ release_id: releaseId });
  const objectName = encodeURIComponent(file.name);
  const paramsObject = {
    release_track_id: releaseTrackId,
    object_name: objectName,
    browser: browserName,
    content_type: file.type,
    file_size: file.size.toString(),
  };
  return makeBackendPostCallWithJsonResponse<UploadReleaseTrackResponse>(
    route,
    paramsObject,
  ).then(promiseEngineEarsHandler);
};
